import {inject, Injectable} from "@angular/core";
import {FarmApiClient} from "src/app/infrastructure/moovement-api/web-api/farm.api-client";
import {DataStorageService} from "src/app/infrastructure/data-storage.service";
import {FixedSamplePoint, SynchronizationStatus} from "src/app/infrastructure/moovement-api/models/asset";
import {FixedSamplePointsStore} from "src/app/domain/assets/fixed-sample-points/fixed-sample-points.store";
import {FixedSamplePointApiClient} from "src/app/infrastructure/moovement-api/web-api/fixed-asset.api-client";
import {tap} from "rxjs";
import {DataType} from "src/app/domain/domain-models";

@Injectable({
  providedIn: 'root'
})
export class FixedSamplePointsService {

  private fixedSamplePointsStore = inject(FixedSamplePointsStore);

  constructor(
    private farmApiClient: FarmApiClient,
    private fixedAssetApiClient: FixedSamplePointApiClient,
    private dataStorageService: DataStorageService
  ) {}

  reset() {
    this.fixedSamplePointsStore.reset();
  }

  loadFixedSamplePoints(farmId: string): void {
    this.farmApiClient.getFixedSamplePoints(farmId).subscribe({
      next: async fixesSamplePoints => {
        for (const fixedSamplePoint of fixesSamplePoints) {
          await this.persist(fixedSamplePoint);
        }
        this.fixedSamplePointsStore.setAllEntities(fixesSamplePoints);
      },
      error: async () => {
        const cachedFixedSamplePoints = await this.dataStorageService.getAllActiveAssetsMatching<FixedSamplePoint>(DataType.fixedSamplePoints, farmId);
        this.fixedSamplePointsStore.setAllEntities(cachedFixedSamplePoints);
      }
    });
  }

  private async persist(fixedSamplePoint: FixedSamplePoint) {
    await this.dataStorageService.saveAsset(DataType.fixedSamplePoints, fixedSamplePoint.farmId, fixedSamplePoint, SynchronizationStatus.upToDate);
  }

  create(fixedSamplePoint: FixedSamplePoint) {
    return this.fixedAssetApiClient.create(fixedSamplePoint).pipe(
      tap(fixedSamplePoint => this.fixedSamplePointsStore.setEntity(fixedSamplePoint)),
      tap(fixedSamplePoint => this.persist(fixedSamplePoint))
    );
  }

  update(fixedSamplePoint: FixedSamplePoint) {
    return this.fixedAssetApiClient.update(fixedSamplePoint).pipe(
      tap(fixedSamplePoint => this.fixedSamplePointsStore.setEntity(fixedSamplePoint)),
      tap(fixedSamplePoint => this.persist(fixedSamplePoint))
    );
  }
}
